'use strict';

export function showEmailPreview({
    ID = '',
    EmailAddress = '',
    Subject = '',
    Body = '',
    ListAttachments = false,
    UserEmailSendID = '',
    BCC = '',
} = {}) {

    var changeEmailURL = '/pages/pop/?' + jQuery.param({
        module: 'email',
        page: 'emailPreview',
        ID: ID,
        EmailAddress: EmailAddress,
        Subject: Subject,
        Body: Body,
        ListAttachments: ListAttachments,
        UserEmailSendID: UserEmailSendID,
        BCC: BCC,
    });

    popWin({
        title: 'Email Preview' ,
        noAutoWidth: true,
        popID: 'emailPreviewPop',
        width: 550,
        modal: true,
        page: changeEmailURL,
        buttons: {
            'Close': function() {
                $(this).dialog('close');
            },
        },
        loadComplete: function(){},
    });

}

export function emailInquiryGridInit ({
    dateDisplayFormat,
    gridContainerID,
    invoiceGridContainerID,
    typeInputName = 'emailType',
    initialType = 'all',
    emailInquiryStartingRows,
    emailInquiryInvoiceStartingRows = 10,
    emailInquiryFormID } = {}){

    var $gridContainer = $('#' + gridContainerID);
    var $invoiceGridContainer = $('#' + invoiceGridContainerID);
    var $emailInquiryForm = $('#' + emailInquiryFormID);
    var $typeInputs = $emailInquiryForm.find("[name='" + typeInputName + "']");
    var typeHints = {
        all: 'Every email sent, with its delivery status',
        invoice: 'Owner, Sent To and invoice PDFs for each email',
    };
    var createdGrids = {};
    var currentType = initialType === 'invoice' ? 'invoice' : 'all';

    function getActiveGrid() {
        return currentType === 'invoice' ? $invoiceGridContainer : $gridContainer;
    }

    function getActiveMethod() {
        return currentType === 'invoice' ? 'getInvoiceEmailHistoryWeb' : 'getEmailHistoryWeb';
    }

    // Grids are only created the first time their view is shown
    function ensureActiveGrid() {
        if (createdGrids[currentType]) {
            return false;
        }
        createdGrids[currentType] = true;

        if (currentType === 'invoice') {
            emailInquiryInvoiceGridCreate({
                gridURL: emailInquiryGetGridURL(emailInquiryFormID, getActiveMethod()),
                dateDisplayFormat: dateDisplayFormat,
                gridContainer: $invoiceGridContainer,
                startingRows: emailInquiryInvoiceStartingRows,
            });
            EQLAPP.COMMON.register({
                'gridID': invoiceGridContainerID,
            });
        } else {
            emailInquiryGridCreate({
                gridURL: emailInquiryGetGridURL(emailInquiryFormID, getActiveMethod()),
                dateDisplayFormat: dateDisplayFormat,
                gridContainer: $gridContainer,
                emailInquiryStartingRows: emailInquiryStartingRows,
            });
            EQLAPP.COMMON.register({
                'gridID': gridContainerID,
            });
        }
        return true;
    }

    function applyType() {
        var isInvoice = currentType === 'invoice';
        var $invoiceOnly = $emailInquiryForm.find('.js-type-invoice-only');

        $invoiceOnly.toggleClass('hide', !isInvoice);
        if (!isInvoice) {
            $invoiceOnly.find('select').val('');
            if ($emailInquiryForm.find("[name='owner_id']").val()) {
                // Hidden in the All view; clear it so it doesn't silently filter that grid
                clearSelection('owner_name', 'owner_id', 'clear_owner', '');
            }
        }
        $('.js-grid-all').toggleClass('hide', isInvoice);
        $('.js-grid-invoice').toggleClass('hide', !isInvoice);

        $typeInputs.each(function(){
            $(this).closest('.ei-type__option').toggleClass('is-active', this.value === currentType);
        });
        $emailInquiryForm.find('.js-type-hint').text(typeHints[currentType]);
    }

    // Debouce Setup
    // Adjust the wait time (in milliseconds) to control the debounce delay
    const debounceWaitTime = 500;
    const debouncedSearch = emailInquiryDebounce(() => {
        getActiveGrid().jqGrid(
            'setGridParam',
            {url: emailInquiryGetGridURL(emailInquiryFormID, getActiveMethod())},
        ).trigger('reloadGrid');
    }, debounceWaitTime);

    // Setup Binds
    $emailInquiryForm.bind('submit', (event) =>{
        event.preventDefault();
    });

    $typeInputs.bind('change', () =>{
        var checkedType = $typeInputs.filter(':checked').val();
        currentType = checkedType === 'invoice' ? 'invoice' : 'all';
        setMiscSetting('email_inquiry_type', currentType);
        applyType();
        if (!ensureActiveGrid()) {
            debouncedSearch();
        }
        window.dispatchEvent(new Event('resize'));
    });

    $emailInquiryForm.find('select').bind('change', (event) =>{
        event.preventDefault();
        debouncedSearch();
    });

    $emailInquiryForm.find('input').not($typeInputs).bind('change keyup', (event) =>{
        event.preventDefault();
        debouncedSearch();
    });

    $emailInquiryForm.find('.js-clear-date-from').bind('click', (event) =>{
        event.preventDefault();
        emailInquiryGridResetDate('invoiceDateFrom');
        debouncedSearch();
    });

    $emailInquiryForm.find('.js-clear-date-to').bind('click', (event) =>{
        event.preventDefault();
        emailInquiryGridResetDate('invoiceDateTo');
        debouncedSearch();
    });

    // Owner multi-select: the search popup writes owner_id / owner_name without firing change,
    // so reload once it closes if the selection moved. pop_win only accepts a global function name.
    const $ownerID = $emailInquiryForm.find("[name='owner_id']");
    let ownerIDsBeforePopup = '';

    window.emailInquiryOwnerPopupClosed = () =>{
        if ($ownerID.val() !== ownerIDsBeforePopup) {
            debouncedSearch();
        }
    };

    $emailInquiryForm.find('.js-changeOwner').bind('click', (event) =>{
        event.preventDefault();
        ownerIDsBeforePopup = $ownerID.val();
        const params = 'clear_btn=clear_owner'
            + '&exclude_ids=' + encodeURIComponent(ownerIDsBeforePopup)
            + '&multiselect=true&hideCol_countryName=true&disableGridFix=true';

        pop_win(
            'ajax_generic_search.cfm',
            'owner',
            'owner_id,owner_name',
            '',
            'emailInquiryOwnerPopupClosed',
            true,
            params,
            '',
            'Owner Select',
            600,
            '',
        );
    });

    $emailInquiryForm.find('.js-clearOwner').bind('click', (event) =>{
        event.preventDefault();
        clearSelection('owner_name', 'owner_id', 'clear_owner', '');
        debouncedSearch();
    });

    // Style buttons
    $('.jq_button').button();

    applyType();
    ensureActiveGrid();

}

// Grid URL
function emailInquiryGetGridURL (emailInquiryFormID, method = 'getEmailHistoryWeb'){
    const $emailInquiryForm = $('#' + emailInquiryFormID);
    const emailInquiryURL = '/components/services/transactionalEmail.cfc?' + jQuery.param({
        method: method,
        invoiceDateFrom: $emailInquiryForm.find("[name='invoiceDateFrom']").val() || '',
        invoiceDateTo: $emailInquiryForm.find("[name='invoiceDateTo']").val() || '',
        recipient: $emailInquiryForm.find("[name='recipient']").val() || '',
        subject: $emailInquiryForm.find("[name='subject']").val() || '',
        message: $emailInquiryForm.find("[name='message']").val() || '',
        batchID: $emailInquiryForm.find("[name='batchID']").val() || '',
        ownerIDs: $emailInquiryForm.find("[name='owner_id']").val() || '',
        invoiceType: $emailInquiryForm.find("[name='invoiceType']").val() || '',
    });
    return emailInquiryURL;
}

// Debounce function to delay the search execution
function emailInquiryDebounce(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

function emailInquiryGridResetDate(dateFieldID){
    const $dataField = $('#' + dateFieldID);
    const $displayField = $('#' + dateFieldID + '_Display');
    const todaysDate = new Date();
    const yearDate = new Date();
    yearDate.setFullYear(yearDate.getFullYear() + 1);
    $dataField.val(todaysDate.toDateString());
    $displayField.datepicker('setDate',todaysDate);
}

function emailInquiryGridCreate({
    gridURL,
    dateDisplayFormat,
    gridContainer,
    emailInquiryStartingRows } = {}){

    gridContainer.jqGrid({
        url: gridURL,
        datatype: 'json',
        colNames: [
            'ID',
            'UserEmailSendID',
            'Created At',
            'Sent To',
            'Sent To Original',
            'Sent To Override',
            'Status',
            'Details',
            'Subject',
            'Message',
            'Attachments',
            'RecipientBCC',
            'IsNomination',
        ],
        colModel: [
            {
                index: 'ID',
                name: 'ID',
                sortable: true,
                sorttype: 'text',
                width: 0,
                hidden: true,
            },
            {
                index: 'UserEmailSendID',
                name: 'UserEmailSendID',
                sortable: true,
                sorttype: 'text',
                width: 0,
                hidden: true,
            },
            {
                name: 'Date',
                index: 'Date',
                width: 85,
                sorttype: 'Date',
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: dateDisplayFormat,
                },
                align: 'center',
                classes: 'pointer',
            },
            {
                index: 'RecipientDisplay',
                name: 'RecipientDisplay',
                sortable: true,
                sorttype: 'text',
                width: 140,
                cellattr: function(rowId, val, rawObject) {

                    var recipientOriginal = gridContainer.jqGrid('getCell',rowId,'RecipientOriginal');
                    var recipientOverride = gridContainer.jqGrid('getCell',rowId,'RecipientOverride');

                    // var recipientOriginal = rawObject[4];
                    // var recipientOverride = rawObject[5];
                    if (recipientOriginal !== recipientOverride){
                        return ('title="Email sent to: ' +
                            recipientOverride +
                            '\r\nOverridden from: ' +
                            recipientOriginal +
                            '" class="recipientOverrided"'
                        );
                    } else {
                        return ('class=""');
                    }
                },
            },
            {
                index: 'RecipientOriginal',
                name: 'RecipientOriginal',
                sortable: true,
                sorttype: 'text',
                width: 19,
                hidden: true,
            },
            {
                index: 'RecipientOverride',
                name: 'RecipientOverride',
                sortable: true,
                sorttype: 'text',
                width: 19,
                classes: 'pointer',
                editable: false,
                hidden: true,
            },
            {
                index: 'Status',
                name: 'Status',
                sortable: true,
                align: 'left',
                width: 140,
                classes: 'pointer',
                editable: false,
            },
            {
                index: 'EmailDetails',
                name: 'EmailDetails',
                sortable: false,
                width: 40,
                classes: 'pointer emailDetails option emailInfo',
                editable: false,
            },
            {
                index: 'Subject',
                name: 'Subject',
                sortable: true,
                sorttype: 'text',
                width: 125,
                classes: 'pointer',
                editable: false,
                hidden: true,
            },
            {
                index: 'MessageBodyText',
                name: 'MessageBodyText',
                sortable: true,
                sorttype: 'text',
                width: 135,
                classes: 'pointer email',
                editable: false,
                hidden: true,
            },
            {
                index: 'Invoices',
                name: 'Invoices',
                sortable: true,
                sorttype: 'text',
                width: 55,
                editable: false,
                align: 'right',
                formatter: function(cellvalue, options, rowObject) {
                    var count = emailInquiryEscapeHtml(cellvalue);
                    return (rowObject && rowObject[12] == 1) ? emailInquiryNominationTag() + ' ' + count : count;
                },
            },
            {
                index: 'RecipientBCC',
                name: 'RecipientBCC',
                sortable: false,
                width: 0,
                hidden: true,
            },
            {
                index: 'IsNomination',
                name: 'IsNomination',
                sortable: false,
                width: 0,
                hidden: true,
            },
        ],
        rowNum: emailInquiryStartingRows,
        rowList: [10,20,30,40],
        autowidth: true,
        height: '100%',
        pager: '#emailInquiryGridPager',
        sortname: 'Date',
        sortorder: 'DESC',
        subGrid: true,
        subGridRowExpanded: function(subGridID, rowID) {
            emailInquiryStatusSubGrid({
                gridContainer: gridContainer,
                subGridID: subGridID,
                rowID: rowID,
                dateDisplayFormat: dateDisplayFormat,
            });
        },
        beforeRequest: function(){},
        loadComplete: function(){
            gridFix('#emailInquiryGrid');
            var recCount = $('#emailInquiryGridPager').find('.ui-pg-selbox').val();
            setMiscSetting('pagination_email_inquiry_main',recCount);
            window.dispatchEvent(new Event('resize'));
        },
        onCellSelect: function (rowid, iCol, cellcontent, e) {
            var $cell = $(e.target);

            // Email Details
            if ($cell.hasClass('emailDetails')) {
                emailInquiryShowDetails(gridContainer, rowid);
            }
        },
    });
}

function emailInquiryShowDetails(gridContainer, rowid) {
    var recipientBCC = $.trim(gridContainer.jqGrid('getCell', rowid, 'RecipientBCC'));
    var previewOptions = {
        ID: gridContainer.jqGrid('getCell', rowid, 'ID'),
        EmailAddress: gridContainer.jqGrid('getCell', rowid, 'RecipientDisplay'),
        Subject: gridContainer.jqGrid('getCell', rowid, 'Subject'),
        Body: gridContainer.jqGrid('getCell', rowid, 'MessageBodyText'),
        ListAttachments: true,
        UserEmailSendID: gridContainer.jqGrid('getCell', rowid, 'UserEmailSendID'),
    };

    if (recipientBCC.length && recipientBCC !== '&nbsp;') {
        previewOptions.BCC = recipientBCC;
    }

    showEmailPreview(previewOptions);
}

function emailInquiryStatusSubGrid({
    gridContainer,
    subGridID,
    rowID,
    dateDisplayFormat } = {}){

    var subGridTableID = subGridID + '_t';
    var pagerID = 'p_' + subGridTableID;
    var userEmailSendID = gridContainer.jqGrid('getCell', rowID, 'UserEmailSendID');
    var subGridURL = '/components/services/transactionalEmail.cfc?' + jQuery.param({
        method: 'getEmailStatusHistoryWeb',
        userEmailSendID: userEmailSendID,
    });

    $('#' + subGridID).html(
        '<table id="' + subGridTableID + '" class="scroll"></table>' +
        '<div id="' + pagerID + '" class="scroll"></div>',
    );

    $('#' + subGridTableID).jqGrid({
        url: subGridURL,
        datatype: 'json',
        colNames: [
            'ID',
            'Status',
            'Created At',
        ],
        colModel: [
            {
                name: 'ID',
                index: 'ID',
                hidden: true,
                sortable: false,
            },
            {
                name: 'Status',
                index: 'Status',
                width: 140,
                sortable: true,
            },
            {
                name: 'Date',
                index: 'Date',
                width: 85,
                sorttype: 'date',
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: dateDisplayFormat,
                },
                align: 'center',
                sortable: true,
            },
        ],
        rowNum: 10,
        rowList: [10,20,30],
        pager: '#' + pagerID,
        sortname: 'Date',
        sortorder: 'DESC',
        height: '100%',
        autowidth: true,
        loadComplete: function(){
            gridFix('#' + subGridTableID);
        },
    });
}

function emailInquiryEscapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function emailInquiryNominationTag() {
    return '<span class="ir-tag ir-tag--nomination">Nomination</span>';
}

function emailInquiryFormatAttachments(cellvalue) {
    if (!$.isArray(cellvalue) || !cellvalue.length) {
        return '';
    }
    var hasNomination = false;
    var chips = $.map(cellvalue, function(invoice) {
        var invoiceNumber = emailInquiryEscapeHtml(invoice.invoiceNumber);
        if (invoice.invoiceType === 'nomination') {
            hasNomination = true;
        }
        return '<span class="ire-chip js-invoice-pdf"' +
            ' data-invoice="' + invoiceNumber + '"' +
            ' data-control-level="' + emailInquiryEscapeHtml(invoice.controlLevelID) + '"' +
            ' title="Open invoice ' + invoiceNumber + ' PDF">Inv ' + invoiceNumber + '</span>';
    }).join(' ');
    return hasNomination ? emailInquiryNominationTag() + ' ' + chips : chips;
}

function emailInquiryFormatOwners(cellvalue) {
    if (!$.isArray(cellvalue) || !cellvalue.length) {
        return '';
    }
    return $.map(cellvalue, function(owner) {
        var ownerURL = '/?' + jQuery.param({ page: 'owner', ownerid: owner.ownerID });
        return '<a class="js-owner-link" href="' + emailInquiryEscapeHtml(ownerURL) + '"' +
            ' title="Go to owner record">' + emailInquiryEscapeHtml(owner.name) + '</a>';
    }).join(', ');
}

function emailInquiryInvoiceGridCreate({
    gridURL,
    dateDisplayFormat,
    gridContainer,
    startingRows } = {}){

    var gridID = gridContainer.attr('id');

    // Plain left click asks first; middle, Ctrl, Cmd and Shift clicks follow the link as normal
    gridContainer.delegate('a.js-owner-link', 'click', function(event){
        if (event.which > 1 || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }
        event.preventDefault();
        var ownerName = $(this).text();
        if (confirm('Go to the owner record for ' + ownerName + '?')) {
            window.location.href = this.href;
        }
    });

    gridContainer.jqGrid({
        url: gridURL,
        datatype: 'json',
        colNames: [
            'ID',
            'UserEmailSendID',
            'Created At',
            'Invoice Owner',
            'Sent To',
            'Sent To Original',
            'Sent To Override',
            'Status',
            'Details',
            'Attachments',
            'Subject',
            'Message',
            'RecipientBCC',
        ],
        colModel: [
            { index: 'ID', name: 'ID', width: 0, hidden: true },
            { index: 'UserEmailSendID', name: 'UserEmailSendID', width: 0, hidden: true },
            {
                name: 'Date',
                index: 'Date',
                width: 85,
                sorttype: 'Date',
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: dateDisplayFormat,
                },
                align: 'center',
            },
            {
                index: 'Owner',
                name: 'Owner',
                sortable: false,
                width: 140,
                title: false,
                formatter: emailInquiryFormatOwners,
            },
            {
                index: 'RecipientDisplay',
                name: 'RecipientDisplay',
                sortable: true,
                width: 140,
                cellattr: function(rowId, val, rawObject) {
                    var recipientOriginal = rawObject[5];
                    if (rawObject[6] == 1) {
                        return 'title="Email sent to: ' + emailInquiryEscapeHtml(val) +
                            '\r\nOverridden from: ' + emailInquiryEscapeHtml(recipientOriginal) +
                            '" class="recipientOverrided"';
                    }
                    return '';
                },
            },
            { index: 'RecipientOriginal', name: 'RecipientOriginal', width: 0, hidden: true },
            { index: 'RecipientOverride', name: 'RecipientOverride', width: 0, hidden: true },
            {
                index: 'Status',
                name: 'Status',
                sortable: true,
                width: 120,
                classes: 'pointer',
            },
            {
                index: 'EmailDetails',
                name: 'EmailDetails',
                sortable: false,
                width: 40,
                classes: 'pointer emailDetails option emailInfo',
            },
            {
                index: 'Attachments',
                name: 'Attachments',
                sortable: false,
                width: 140,
                title: false,
                formatter: emailInquiryFormatAttachments,
            },
            { index: 'Subject', name: 'Subject', width: 0, hidden: true },
            { index: 'MessageBodyText', name: 'MessageBodyText', width: 0, hidden: true },
            { index: 'RecipientBCC', name: 'RecipientBCC', width: 0, hidden: true },
        ],
        rowNum: startingRows,
        rowList: [10,20,30,40],
        autowidth: true,
        height: '100%',
        pager: '#' + gridID + 'Pager',
        sortname: 'Date',
        sortorder: 'DESC',
        subGrid: true,
        subGridRowExpanded: function(subGridID, rowID) {
            emailInquiryStatusSubGrid({
                gridContainer: gridContainer,
                subGridID: subGridID,
                rowID: rowID,
                dateDisplayFormat: dateDisplayFormat,
            });
        },
        loadComplete: function(){
            gridFix('#' + gridID);
            var recCount = $('#' + gridID + 'Pager').find('.ui-pg-selbox').val();
            setMiscSetting('pagination_email_inquiry_invoice', recCount);
            window.dispatchEvent(new Event('resize'));
        },
        onCellSelect: function (rowid, iCol, cellcontent, e) {
            var $target = $(e.target);
            var $chip = $target.closest('.js-invoice-pdf');

            if ($chip.length) {
                EQLAPP.BILLING.showInvoicePDF({
                    invoiceNumber: $chip.attr('data-invoice'),
                    controlLevelID: $chip.attr('data-control-level'),
                });
                return;
            }

            if ($target.closest('td').hasClass('emailDetails')) {
                emailInquiryShowDetails(gridContainer, rowid);
            }
        },
    });
}